
    import { Component, Vue, Prop } from 'vue-property-decorator';
   
    @Component
    export default class Spinner extends Vue {
        @Prop({required: false, default:"#4b4b4b"})
        color!: string;

        @Prop({required: false, default:"15"})
        diameter!: string;
    }

